import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const getAllTimeTypes = (
    token: string,
    backend: string,
) => {
    return fetch(
        `${getApiUrl(backend)}get_all_timeTypes`,
        {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );
};

export default getAllTimeTypes;
